export default __webpack_public_path__ + "images/DQ.68db93c.png";